import request from '@/utils/request';

/* 문자메시지 서비스 이용상태 조회 */
export function getMsgsvcStat(data) {
  return request({
    url: '/msgsvc/Join/checkMsgsvc',
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data
  })
}